import { ValidationErrors } from '@angular/forms';

export const getCommonErrorMessage = (errors: ValidationErrors | null, label: string = 'Field'): string => {
    if (!errors) { return ''; }

    const errorMap: { [key: string]: (args: any) => string } = {
        'required':      () => $localize`${label} is required.`,
        'email':         () => $localize`Please enter a valid email address.`,
        'minlength':     (a) => $localize`${label} must be at least ${a.requiredLength} characters (current: ${a.actualLength}).`,
        'maxlength':     (a) => $localize`${label} cannot exceed ${a.requiredLength} characters.`,
        'pattern':       () => $localize`The format of ${label} is invalid.`,
        'min':           (a) => $localize`${label} must be at least ${a.min}.`,
        'max':           (a) => $localize`${label} cannot be more than ${a.max}.`,
        'requiredTrue':  () => $localize`You must accept the terms and conditions.`,
    };

    // Get the first error key found
    const firstKey = Object.keys(errors)[0];

    if (errorMap[firstKey]) {
        return errorMap[firstKey](errors[firstKey]);
    }

    return '';
};